<template>
    <div class="stats-page">
        <page-hero title="Στατιστικά" eyebrow="Statistics" compact />
        <div class="cl-page">
            <v-row no-gutters class="my-0 py-0 px-2">
                <v-col cols="12" class="px-0 py-0 mb-6" align="center">
                    <v-row class="cl-card cl-card--accent mx-0">
                        <v-col cols="12" md="4" align="center">
                            <v-select
                                v-model="season"
                                color="teal"
                                item-color="teal"
                                label="Σεζόν"
                                :items="seasons"
                                item-text="name"
                                return-object
                                dark
                            />
                        </v-col>
                        <v-col v-if="!$vuetify.breakpoint.mobile" cols="1">
                            <v-divider
                                vertical
                                color="teal"
                                class="custom-divider"
                            />
                        </v-col>
                        <v-col cols="12" md="3" align="center">
                            <v-select
                                v-model="phase"
                                label="Φάση"
                                color="teal"
                                item-color="teal"
                                :items="phaseOptions"
                                item-text="title"
                                item-value="value"
                                dark
                            />
                        </v-col>
                        <v-col v-if="!$vuetify.breakpoint.mobile" cols="1">
                            <v-divider
                                vertical
                                color="teal"
                                class="custom-divider"
                            />
                        </v-col>
                        <v-col cols="12" md="3" align="center">
                            <v-select
                                v-model="league"
                                color="teal"
                                item-color="teal"
                                :items="leagues"
                                label="League"
                                item-text="title"
                                return-object
                                item-value="id"
                                dark
                                @change="fetchStats()"
                            />
                        </v-col>
                        <v-col cols="12" align="center">
                            <v-chip-group
                                v-model="option"
                                column
                                mandatory
                                style="display: inline-block;"
                            >
                                <v-chip
                                    v-for="(item, index) in ['Παίκτες', 'Ομάδα']"
                                    :key="index"
                                    filter
                                    filter-icon="mdi-basketball-hoop"
                                    active-class="custom-teal selected-chip"
                                    color="white"
                                    large
                                    mandatory
                                    class="font-weight-bold"
                                >
                                    {{ item }}
                                </v-chip>
                            </v-chip-group>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col v-for="(statHeader, index) in statsHeaders" :key="index" cols="12" md="6" class="mb-5 px-1">
                    <stat-card :loading="loading" :stat-header="statHeader" :stats="getDisplayData(statHeader)" :option="option === 1" @scrollToStats="scrollToStats()" />
                </v-col>
                <v-col ref="stats" cols="12" class="white " align="center">
                    <v-chip-group
                        v-model="option2"
                        column
                        mandatory
                        style="display: inline-block;"
                    >
                        <v-chip
                            v-for="(item, index) in ['Μέσοι Όροι', 'Σύνολο']"
                            :key="index"
                            filter
                            filter-icon="mdi-basketball-hoop"
                            active-class="custom-teal selected-chip"
                            color="white"
                            large
                            mandatory
                            class="font-weight-bold"
                        >
                            {{ item }}
                        </v-chip>
                    </v-chip-group>
                </v-col>
                <v-col cols="12">
                    <players-stats v-if="!option" :players="playerStats" :option="option2" :generic="true" />
                    <teams-stats v-else :teams="stasData" :option="option2" :generic="true" />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import PageHero from '@/components/PageHero'
    import StatCard from '@/components/StatCard'
    import statsService from '@/services/stats.js'
    import leagueService from '@/services/league.js'
    import PlayersStats from '@/components/PlayersStats'
    import TeamsStats from '@/components/TeamsStats'
    import seasonService from '@/services/season.js'
    import moment from 'moment'
    import { availablePhases, pickPhase } from '@/utils/phases'
    import { foulsOf } from '@/utils/teamStats'

    const PHASE_OPTIONS = [
        { title: 'Regular Season', value: 'regular_season' },
        { title: 'PlayOffs', value: 'playoffs' }
    ]

    export default {
        components: { PageHero, StatCard, PlayersStats, TeamsStats },
        data() {
            return {
                statsHeaders: [
                    { text: 'Pts', value: 'points' },
                    { text: '2P Made', value: 'twoPointsMade' },
                    { text: '3P Made', value: 'threePointsMade' },
                    { text: 'FT Made', value: 'freeThrowsMade' },
                    { text: 'OR', value: 'offensiveRebounds' },
                    { text: 'DR', value: 'defensiveRebounds' },
                    { text: 'TR', value: 'rebounds' },
                    { text: 'AST', value: 'assists' },
                    { text: 'STL', value: 'steals' },
                    { text: 'TO', value: 'turnovers' },
                    { text: 'BLK', value: 'blockedShots' },
                    { text: 'FC', value: 'fouls' }
                ],
                stasData: null,
                playerStats: [],
                teamStats: [],
                leagues: [],
                league: null,
                option: 0,
                option2: 0,
                type: 'regular_season',
                phase: 'regular_season',
                season: null,
                seasons: [],
                // what the season has to show (null: unknown, all the options), and the season it is of
                seasonPhases: null,
                seasonPhasesId: null,
                loading: false,
                // the stats of the latest choice only
                statsRequest: 0,
                maxRound: 0
            }
        },
        computed: {
            // only the phases of the league with a match played
            phaseOptions() {
                return availablePhases(PHASE_OPTIONS, this.seasonPhases, this.league, 'played')
            }
        },
        watch: {
            phaseOptions() {
                this.fixPhase()
            },
            season: {
                handler(value, previous) {
                    // another season: nothing on screen until its stats come
                    if (previous) {
                        this.statsRequest++
                        this.leagues = []
                        this.league = null
                        this.statsData = null
                        this.stasData = null
                        this.playerStats = []
                        this.teamStats = []
                        this.maxRound = 0
                        this.$store.dispatch('setLeagueFilter', null)
                    }
                    if (value) {
                        this.filter = null
                        this.fetchSeasonPhases(value)
                        this.fetchAllLeagues()
                    }
                }
            },
            league: {
                handler() {
                    this.fetchStats()
                }
            },
            phase: {
                handler() {
                    this.fetchStats()
                }
            }
        },
        created() {
            this.fetchAllSeasons()
            this.fetchStats()
        },
        methods: {
            fetchSeasonPhases(season) {
                this.seasonPhasesId = null
                const done = (phases) => {
                    if (!this.season || this.season.id !== season.id) return
                    this.seasonPhases = phases
                    this.seasonPhasesId = season.id
                    this.fixPhase()
                    this.fetchStats()
                }
                seasonService.getPhases(season.id).then(resp => done(resp.data || null)).catch(() => done(null))
            },
            // a phase without a match played has no stats: not an option
            fixPhase() {
                const config = this.$store.getters.getConfig
                this.phase = pickPhase(this.phase, this.phaseOptions, config && config.activePhase)
            },
            fetchAllSeasons() {
                seasonService.getSeasons(1, 100).then(resp => {
                    this.seasons = resp.data.content
                    this.season = resp.data.content.filter(element => moment().isBetween(moment(element.startDate), moment(element.endDate)))[0]
                })
            },
            getDisplayData(statHeader) {
                if (this.maxRound > 0) {
                    const temp = JSON.parse(JSON.stringify(this.option === 1 ? this.statsData : this.playerStats.filter((element) => {
                        return element.stats.length >= (this.maxRound * 0.55)
                    })))
                    temp.sort((a, b) => b.avg[statHeader.value] - a.avg[statHeader.value])
                    return temp.length > 5 ? temp.slice(0, 5) : temp
                } else {
                    return []
                }
            },
            fetchStats() {
                // the phases of the season first: the phase may not be an option
                if (this.season && this.league && this.seasonPhasesId === this.season.id) {
                    this.loading = true
                    this.$store.dispatch('setLeagueFilter', this.league)
                    const request = ++this.statsRequest
                    statsService.getStatsByLeague(this.league.id, this.phase, this.season.id).then(resp => {
                        if (request !== this.statsRequest) return
                        this.statsData = resp.data
                        this.calculateTeamsStats(resp.data)
                        this.calculatePlayersStats(resp.data)
                        this.getPlayersStats()
                    })
                }
            },
            fetchAllLeagues() {
                // the leagues of the season in any phase: the phase is picked after the league
                const season = this.season
                leagueService.getLeagues(1, 100, season, null).then(resp => {
                    if (this.season !== season) return
                    this.leagues = resp.data
                    this.league = this.$store.getters.getLeagueFilter ? this.$store.getters.getLeagueFilter : (this.leagues[0] || null)
                })
            },
            calculateTeamsStats(data) {
                data.forEach(team => {
                    this.teamStats = []
                    team.players.forEach(player => {
                        this.teamStats = this.teamStats.concat(player.stats)
                    })
                    team.stats = this.groupByMatch()
                    team.avg = this.getAverageStats(team)
                    team.cum = this.getCummulativeStats(team)
                    team.gp = team.stats.length
                    if (team.stats.length > this.maxRound) {
                        this.maxRound = team.stats.length
                    }
                })
                this.stasData = data
            },
            findMatches() {
                const matches = new Set()
                this.teamStats.forEach(stat => {
                    matches.add(stat.matchId)
                })
                return matches
            },
            groupByMatch() {
                const matches = this.findMatches()
                const data = []
                matches.forEach(match => {
                    const stats = {
                        points: 0,
                        rebounds: 0,
                        assists: 0,
                        steals: 0,
                        turnovers: 0,
                        blockedShots: 0,
                        twoPointsMade: 0,
                        twoPointAttempts: 0,
                        threePointsMade: 0,
                        threePointAttempts: 0,
                        freeThrowsMade: 0,
                        freeThrowAttempts: 0,
                        offensiveRebounds: 0,
                        defensiveRebounds: 0,
                        personalFouls: 0,
                        fouls: 0
                    }
                    this.teamStats.forEach(stat => {
                        if (match === stat.matchId) {
                            for (const key of Object.keys(stats)) {
                                stats[key] += key === 'fouls' ? foulsOf(stat) : stat[key]
                            }
                        }
                    })
                    data.push(stats)
                })
                return data
            },
            getPlayersStats() {
                this.playerStats = []
                this.stasData.forEach(team => {
                    this.playerStats = this.playerStats.concat(team.players)
                })
                this.loading = false
                return this.playerStats
            },
            calculatePlayersStats(data) {
                data.forEach(team => {
                    team.players.forEach(player => {
                        player.team = team.name
                        player.teamLogo = team.logo
                        player.avg = this.getAverageStats(player)
                        player.cum = this.getCummulativeStats(player)
                    })
                })
                this.stasData = data
            },
            getCummulativeStats(entity) {
                const stats = {
                    points: 0,
                    rebounds: 0,
                    assists: 0,
                    steals: 0,
                    turnovers: 0,
                    blockedShots: 0,
                    twoPointsMade: 0,
                    twoPointAttempts: 0,
                    threePointsMade: 0,
                    threePointAttempts: 0,
                    freeThrowsMade: 0,
                    freeThrowAttempts: 0,
                    offensiveRebounds: 0,
                    defensiveRebounds: 0,
                    personalFouls: 0,
                    fouls: 0,
                    pir: 0,
                    playTimeInSecs: 0
                }
                entity.stats.filter((element) => !element.cup).forEach(element => {
                    for (const key of Object.keys(stats)) {
                        stats[key] += key === 'fouls' ? foulsOf(element) : element[key]
                    }
                })
                return stats
            },
            getAverageStats(entity) {
                const stats = {
                    points: 0,
                    rebounds: 0,
                    assists: 0,
                    steals: 0,
                    turnovers: 0,
                    blockedShots: 0,
                    twoPointsMade: 0,
                    twoPointAttempts: 0,
                    threePointsMade: 0,
                    threePointAttempts: 0,
                    freeThrowsMade: 0,
                    freeThrowAttempts: 0,
                    offensiveRebounds: 0,
                    defensiveRebounds: 0,
                    personalFouls: 0,
                    fouls: 0,
                    pir: 0,
                    playTimeInSecs: 0
                }
                const temp = entity.stats.filter((element) => !element.cup)
                temp.forEach(element => {
                    for (const key of Object.keys(stats)) {
                        stats[key] += key === 'fouls' ? foulsOf(element) : element[key]
                    }
                })

                Object.keys(stats).forEach(element => {
                    if (temp.length) {
                        stats[element] = stats[element] / temp.length
                    } else {
                        stats[element] = 0
                    }
                })
                return stats
            },
            scrollToStats() {
                this.$refs.stats.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }
</script>

<style scoped>
.v-chip::before {
    background-color: white !important;
}

.selected-chip {
    color: white;
}
</style>
